import { useSubscription } from "@apollo/client";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAllWidgetContextsAC } from "@/messenger/sagas/widget";

import { setRequestTrackerAC } from "@/messenger/actions/requestTracker";
import { RequestURIs } from "@/messenger/constants/requests";
import { upsertContacts } from "@/messenger/ducks/entities/contacts";
import { removeConversationAC, upsertConversations } from "@/messenger/ducks/entities/conversations";
import { GetTeamConversationSubscription } from "@/messenger/graphql/subscriptions";
import { createRequestTracker } from "@/messenger/models/requestTracker";
import { normalizeFindAllConversationsResponse } from "@/messenger/utils/normalize";
import { Conversation } from "@/messenger/types/graphql/autogenerated";
import { createConversationStructure } from "@/messenger/utils/conversation.helper";
import { representativesSelectors } from "@/messenger/ducks/entities/representatives";
import { conversationsSelector } from "@/messenger/selectors";
import { CHAT } from "@/messenger/constants/routing";
import { fetchNumbers } from "@/messenger/utils/helpers";


const GetConversationsSubscription = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const representatives = useSelector(representativesSelectors.selectAll);
    const prevConvos = useSelector(conversationsSelector);
    const [numbers, setNumbers] = useState<string[]>(null)


    const removeConversationCallback = (id: string, activeConvoId: string, nextConvoId: string) => {
        if (id === activeConvoId) {
            if (nextConvoId) {
                //history.push(`/${CHAT}/${nextConvoId}`);
                history.push(`/${CHAT}`);
            } else {
                history.push(`/${CHAT}`);
            }
        }
    };

    useSubscription(GetTeamConversationSubscription, {
        onSubscriptionData: ({ subscriptionData }: any) => {
            try {
                const convoList = subscriptionData?.data?.all?.[0]?.services?.[0]?.conversations;
                const structuredConvo: Conversation[] = convoList.map(convo => createConversationStructure(convo, representatives));
                const convos = structuredConvo.filter(item => numbers.includes(item.representativePhone));

                const latestConvoIds = []
                convos.forEach(convo => latestConvoIds.push(convo.id));

                prevConvos.forEach(convo => {
                    if(!latestConvoIds.includes(convo.id)) {
                        dispatch(removeConversationAC({ conversationId: convo.id }, removeConversationCallback));
                    }
                });

                const normalizedConvoData = normalizeFindAllConversationsResponse(convos);
                
                if (Object.keys(normalizedConvoData.entities.conversations || []).length) {
                    dispatch(upsertConversations(normalizedConvoData.entities));
                }

                if (Object.keys(normalizedConvoData.entities.contacts || []).length) {
                    dispatch(upsertContacts(normalizedConvoData.entities));
                }

                dispatch(setRequestTrackerAC(createRequestTracker(RequestURIs.GET_CONVERSATIONS, {
                    complete: true,
                    loading: false,
                    sent: true,
                })));

                // accounts for race condition case where widgets load before conversation, they receive context once convos finish loading.
                dispatch(updateAllWidgetContextsAC());

            } catch (e) {
                console.error(e);
            }
        },

    });

    const fetchOutboundNumbers = async() => {
        const outboundNumbers: { outbound_address: string }[] = await fetchNumbers();
        if(outboundNumbers) {
            const numArray = outboundNumbers.map(item => item.outbound_address)
            setNumbers(numArray);
        }
    }

    useEffect(() => {
        fetchOutboundNumbers()
        dispatch(setRequestTrackerAC(createRequestTracker(RequestURIs.GET_CONVERSATIONS, {
            complete: false,
            loading: true,
            sent: true,
        })));
    }, []);

    return null;
};

export default GetConversationsSubscription;